import { CHANGE_NAME } from "./actionTypes";

// Async Call example
export const anotherName = () => async (dispatch) => {
  const data = await fetch("https://jsonplaceholder.typicode.com/users");
  const res2 = await data.json();
  dispatch({ type: CHANGE_NAME, payload: res2[1].name });
};
